<div class="step-container registration-select-membership">
  <ng-container *ngIf="membershipOptions">
    <h2 class="heading-title mb-3 mt-0">{{ 'fgbcl.registration.select.membership.heading' | translate }}</h2>
    <p
      class="membership-option-instructions"
      [innerHtml]="'fgbcl.registration.select.membership.instruction' | translate | markdownTranslate"
    ></p>

    @if (membershipOptions?.length > 0) {
      <div class="membership-options-list mb-3">
        <div class="membership-option-container" *ngFor="let membershipOption of membershipOptions">
          <div class="d-flex justify-content-center mt-3">
            <img
              class="membership-option-img"
              alt=""
              src="{{ membershipOption.ImageUrl | contentImage: '3' }}"
              class="membership-option-image"
            />
          </div>
          <div class="membership-option-details">
            <div class="membership-option-name">{{ membershipOption.DisplayName }}</div>
            <h4 class="membership-option-price">
              @if (membershipOption.MerchantPrice === 0) {
                {{ 'fgbcl.registration.select.membership.free' | translate }}
              } @else {
                {{ membershipOption.MerchantPrice / 100 | FortressCurrencyPipe }}
              }
            </h4>

            <div class="select-membership-label">
              {{ 'fgbcl.registration.select.membership.benefits.label' | translate }}
            </div>
            <div class="select-membership-description">
              <p [innerHtml]="membershipOption.Description | markdownTranslate"></p>
            </div>
            <div class="action-wrapper">
              <button
                class="btn btn-primary"
                [class.selected]="selectedMembershipOptionId === membershipOption.MembershipOptionId"
                (click)="setSelected(membershipOption.MembershipOptionId)"
              >
                @if (selectedMembershipOptionId === membershipOption.MembershipOptionId) {
                  {{ 'fgbcl.registration.select.membership.selected' | translate }}
                } @else {
                  {{ 'fgbcl.registration.select.membership.select' | translate }}
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </ng-container>
  <div class="registration-navigataion-button-container">
    <fgbcl-registration-navigation
      (nextButtonClicked)="submitStep()"
      [stepType]="stepType"
      [hideNextBtn]="!selectedMembershipOptionId"
    ></fgbcl-registration-navigation>
  </div>
</div>
